import { render, staticRenderFns } from "./privacyPolicyStatement.vue?vue&type=template&id=0aa27311&scoped=true&"
import script from "./privacyPolicyStatement.vue?vue&type=script&lang=js&"
export * from "./privacyPolicyStatement.vue?vue&type=script&lang=js&"
import style0 from "./privacyPolicyStatement.vue?vue&type=style&index=0&id=0aa27311&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa27311",
  null
  
)

export default component.exports